import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const SECTIONS = [
  {
    title: '1. Taraflar ve Kapsam',
    content: `Bu Kullanım Koşulları, Ankara Travelers Turizm A.Ş. ("Şirket") ile web sitesini ziyaret eden veya hizmetlerinden yararlanan kişiler ("Kullanıcı") arasındaki ilişkiyi düzenlemektedir.\n\nWeb sitemizi kullanarak veya herhangi bir hizmetten yararlanarak bu koşulları kabul etmiş sayılırsınız. Koşulları kabul etmiyorsanız lütfen sitemizi kullanmayı bırakınız.`,
  },
  {
    title: '2. Hizmet Tanımı',
    content: `Ankara Travelers; günübirlik turlar, konaklamalı turlar, ulaşımlı tatil paketleri ve yurt dışı turları gibi seyahat hizmetleri sunmaktadır. Şirket, hizmet içeriklerini, fiyatlarını ve programlarını önceden haber vermeksizin değiştirme hakkını saklı tutar.`,
  },
  {
    title: '3. Rezervasyon ve Ödeme Koşulları',
    content: `Rezervasyon işlemi, toplam tur ücretinin %30\'unun depozito olarak ödenmesiyle kesinleşir. Kalan tutar, tur başlangıcından en az 3 iş günü önce ödenmelidir.\n\nÖdeme yükümlülüğünün yerine getirilmemesi halinde Şirket, rezervasyonu iptal etme ve depozito ücretini iade etmeme hakkına sahiptir.\n\nFiyatlar Türk Lirası (TL) veya Euro (€) cinsinden belirlenmiş olup döviz kuru değişikliklerinden kaynaklanan fiyat farklılıklarına ilişkin Şirket herhangi bir sorumluluk üstlenmez.`,
  },
  {
    title: '4. İptal ve İade Politikası',
    content: `İptal koşulları aşağıdaki tabloya göre uygulanır:\n\n• Tur tarihinden 7+ gün önce: %100 iade\n• Tur tarihinden 3-7 gün önce: %50 iade\n• Tur tarihinden 3 günden az: İade yapılmaz\n\nBeklenmedik durumlar (doğal afet, seyahat yasağı vb.) nedeniyle iptallerde, Şirket ile müşteri karşılıklı mutabakat çerçevesinde çözüme kavuşturur.`,
  },
  {
    title: '5. Kullanıcı Sorumlulukları',
    content: `Kullanıcı;\n\n• Rezervasyon sırasında verdiği bilgilerin doğru ve eksiksiz olduğunu beyan eder.\n• Gerekli belgeleri (pasaport, vize, sağlık sertifikası vb.) temin etmekle yükümlüdür.\n• Tur kurallarına, rehber talimatlarına ve güvenlik uyarılarına uymakla sorumludur.\n• Diğer tur katılımcılarının konforunu ve güvenliğini tehlikeye atacak davranışlardan kaçınmalıdır.\n\nBu yükümlülüklere aykırı davranan kullanıcılar, herhangi bir iade yapılmaksızın turdan çıkarılabilir.`,
  },
  {
    title: '6. Sorumluluk Sınırlaması',
    content: `Şirket;\n\n• Doğal afetler, hava koşulları, grevler veya diğer mücbir sebeplerden kaynaklanan program değişikliklerinden sorumlu tutulamaz.\n• Üçüncü taraf hizmet sağlayıcılarının (oteller, havayolları, taşıma firmaları) kusur ve hatalarından doğrudan sorumlu değildir.\n• Seyahat sırasında yaşanan kişisel kayıp, hasar veya yaralanmalar için yalnızca sigorta kapsamı dahilinde sorumluluğu kabul eder.`,
  },
  {
    title: '7. Fikri Mülkiyet',
    content: `Web sitemizdeki tüm içerikler (metinler, fotoğraflar, videolar, logolar, tasarımlar) Ankara Travelers\'a aittir veya lisanslı kullanımdadır. Şirketin yazılı izni olmadan bu içeriklerin kopyalanması, dağıtılması veya ticari amaçlarla kullanılması yasaktır.`,
  },
  {
    title: '8. Uygulanacak Hukuk',
    content: `Bu Kullanım Koşulları, Türkiye Cumhuriyeti kanunlarına tabidir. Anlaşmazlıkların çözümünde Ankara Mahkemeleri ve İcra Daireleri yetkilidir.\n\nSon güncelleme: Ocak 2025`,
  },
];

export default function KullanimKosullariPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  const schemaOrg = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': `${siteUrl}/kullanim-kosullari`,
    url: `${siteUrl}/kullanim-kosullari`,
    name: 'Kullanım Koşulları | Ankara Travelers',
    description: 'Ankara Travelers kullanım koşulları. Rezervasyon, ödeme, iptal politikası ve kullanıcı sorumlulukları hakkında yasal bilgiler.',
    inLanguage: 'tr-TR',
    dateModified: '2025-01-01',
    publisher: {
      '@type': 'TravelAgency',
      name: 'Ankara Travelers',
    },
  };

  return (
    <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors duration-300">
      <title>Kullanım Koşulları | Ankara Travelers</title>
      <meta name="description" content="Ankara Travelers kullanım koşulları. Rezervasyon ve ödeme şartları, iptal politikası, kullanıcı sorumlulukları ve hukuki bilgiler. Hizmetlerimizden yararlanmadan önce okuyunuz." />
      <meta name="keywords" content="Ankara Travelers kullanım koşulları, tur rezervasyon şartları, iptal politikası" />
      <link rel="canonical" href={`${siteUrl}/kullanim-kosullari`} />
      <meta property="og:title" content="Kullanım Koşulları | Ankara Travelers" />
      <meta property="og:url" content={`${siteUrl}/kullanim-kosullari`} />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaOrg) }}
      />
      <Navbar />

      {/* Hero */}
      <section className="pt-20 bg-gray-900 dark:bg-gray-950">
        <div className="max-w-3xl mx-auto px-6 py-20 text-center">
          <div className="w-16 h-16 flex items-center justify-center bg-white/10 rounded-2xl mx-auto mb-6">
            <i className="ri-file-list-3-line text-3xl text-orange-400" />
          </div>
          <h1 className="text-4xl font-bold text-white mb-4">Kullanım Koşulları</h1>
          <p className="text-gray-400 text-base">Son güncelleme: Ocak 2025</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16">
        <div className="max-w-3xl mx-auto px-6">
          {/* Intro */}
          <div className="bg-orange-50 dark:bg-orange-900/10 border border-orange-100 dark:border-orange-800/30 rounded-xl p-6 mb-10">
            <p className="text-gray-700 dark:text-gray-300 text-sm leading-relaxed">
              Lütfen bu Kullanım Koşullarını dikkatlice okuyunuz. Ankara Travelers web sitesini veya hizmetlerini kullanmadan önce bu koşulları anladığınızdan emin olunuz. Hizmetlerimizden yararlanmanız, bu koşulları kabul ettiğiniz anlamına gelir.
            </p>
          </div>

          <div className="space-y-8">
            {SECTIONS.map(sec => (
              <div key={sec.title} className="border-b border-gray-100 dark:border-gray-800 pb-8 last:border-0">
                <h2 className="text-base font-bold text-gray-900 dark:text-white mb-4">{sec.title}</h2>
                <div className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed whitespace-pre-line">
                  {sec.content}
                </div>
              </div>
            ))}
          </div>

          {/* Notice */}
          <div className="mt-12 bg-amber-50 dark:bg-amber-900/10 border border-amber-200 dark:border-amber-800/30 rounded-xl p-6">
            <div className="flex items-start gap-3">
              <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-information-line text-amber-600" />
              </div>
              <p className="text-sm text-amber-800 dark:text-amber-300 leading-relaxed">
                Bu koşullar herhangi bir zamanda değiştirilebilir. Değişiklikler web sitemizde yayımlandıktan sonra geçerli olur. Güncel koşullar için bu sayfayı düzenli olarak incelemenizi öneririz.
              </p>
            </div>
          </div>

          {/* Contact */}
          <div className="mt-8 bg-gray-50 dark:bg-gray-800 rounded-xl p-6">
            <h3 className="font-bold text-gray-900 dark:text-white mb-2">Sorularınız İçin</h3>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-4">
              Kullanım koşullarımız hakkında sorularınız için bizimle iletişime geçebilirsiniz.
            </p>
            <div className="space-y-2">
              <div className="flex items-center gap-3 text-sm text-gray-600 dark:text-gray-400">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-mail-line text-orange-500" />
                </div>
                info@ankaratravelers.com
              </div>
              <div className="flex items-center gap-3 text-sm text-gray-600 dark:text-gray-400">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line text-orange-500" />
                </div>
                +90 540 001 5806
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
